<template>
   <div v-if="apploaded && !everLoadedData">
   </div>

  <div v-if="loadedAdvertsInfoBlock && loadedAdvertsInfoBlock.length">
    <div v-for="loadedAdvert in loadedAdvertsInfoBlock.slice(0, 1)" :key="loadedAdvert.id">
        <div v-if="loadedAdvert && loadedAdvert.type === 'INFOBLOCK'">
            <div v-html="changeTextAndImage(loadedAdvert.html, loadedAdvert.baseUrl)"></div>
        </div>
    </div>
  </div>

  <div v-if="loading">
      <img class="d-none d-md-block" style="opacity:0.6;" src="/wp-content/themes/understrap-child/fidelio-templates/images/EntwicklerDE_21_placeholder_BRAND_cover.svg" alt="">
      <img class="d-md-none" style="opacity:0.6;" src="/wp-content/themes/understrap-child/fidelio-templates/images/EntwicklerDE_21_placeholder_BRAND_cover.svg" alt="">
  </div>

</template>
  
  <script>
  import {
      ApolloClient,
      InMemoryCache
  } from '@apollo/client/core'
  import {
      provideApolloClient,
      useQuery
  } from "@vue/apollo-composable";
  import CONCORD_QUERIES from "../../services/concord_queries.js"
  import {
      watch
  } from 'vue'
  export default {
      name: "categoryColumn",
          props: {
          settingsPerm: Object,
          isDevMioActive: Boolean,
          isDevmioNlActive: Boolean,
      },
      data() {
          return {
              loadedAdvertsInfoBlock: []
          }
      },
  
      created() {
           const cache = new InMemoryCache();
           const customHeaders = {
              platform: 'web', // Add your custom header(s) here
              App: this.settingsPerm.isDevmioNlActive
              ? "devmionl"
              : this.settingsPerm.isDevMioActive
              ? "devmio"
              : "entwickler",
              'App-Version': '3.10.10',
          };
          const apolloClient = new ApolloClient({
              cache,
              uri: this.settingsPerm.concordBackendURL,
              headers: customHeaders,
          })
          provideApolloClient(apolloClient)
          let variablesForQuery = {
                page: 1,
                pagesize: 2,
                keyword: this.settingsPerm.categoryID, // Use 'keyword' here
                apploaded: false,
                everLoadedData: false,
                loading: false,
          };

          const {
              result
          } = useQuery(CONCORD_QUERIES.CAT_SPECIFIC_ADD_EVENT, variablesForQuery);
          watch(result, value => {
              if(value && value.aggregatedCategory && value.aggregatedCategory.adverts && value.aggregatedCategory.adverts.Adverts && value.aggregatedCategory.adverts.Adverts.length){
                value.aggregatedCategory.adverts.Adverts.forEach((ad) => {
                    this.loadedAdvertsInfoBlock.push(ad);
                });
            }
          }); 
        },

        methods: {
            changeTextAndImage(articleContent, articleBaseURL){
            let htmlToDisplay = false;
          if (articleContent && articleContent.length && articleBaseURL && articleBaseURL.length){
              let parser,xmlDoc;
              parser = new DOMParser();
              xmlDoc = parser.parseFromString(articleContent, 'text/html');
              if (articleBaseURL) {
                  const images = xmlDoc.getElementsByTagName('img');
                  if (images && images.length) {
                    for (let i = 0; i < images.length; i++) {
                      const theCurrentImage = images[i];
                      if (theCurrentImage.attributes) {
                        if (theCurrentImage.attributes.getNamedItem('src')) {
                          const srcItem = theCurrentImage.attributes.getNamedItem('src');
                          if (srcItem.value) {
                            const src = xmlDoc.createAttribute('src');
                            src.value = articleBaseURL + srcItem.value;
                            theCurrentImage.attributes.setNamedItem(src);
                          }
                        }
                      }
                    }
                  }
              }

              const vtags = xmlDoc.getElementsByTagName('video');
              if (vtags && vtags.length) {
                for (let i = 0; i < vtags.length; i++) {
                  const thecurrentVTag = vtags[i];
                  if (thecurrentVTag.attributes) {
                    const poster = xmlDoc.createAttribute('poster');
                    poster.value = '/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/poster-video.png';
                    thecurrentVTag.attributes.setNamedItem(poster);
                  }
                }
              }

              const atags = xmlDoc.getElementsByTagName('a');
              if (atags && atags.length) {
                for (let i = 0; i < atags.length; i++) {
                  const thecurrentATag = atags[i];
                  if (thecurrentATag.attributes) {
                    const target = xmlDoc.createAttribute('target');
                    target.value = '_blank';
                    thecurrentATag.attributes.setNamedItem(target);
                  }
                }
              }
              htmlToDisplay = xmlDoc.body.innerHTML;
          }
          return htmlToDisplay
          
      },

        },
  };
  </script>
